import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Service } from "../shared/services/service";
import { Funcoes } from "../funcoes";

@Injectable()
export class MercadoInternoVariedadesService extends Service {
  protected url: string = this.dominio + "/adm/mercado-interno-mercadorias-variedades/";

  constructor(protected http: Http, protected func: Funcoes) {
    super();
  }
}



// WEBPACK FOOTER //
// ./src/app/mercado-interno-mercadorias/mercado-interno-variedades.service.ts